import { useBatchContractSweepFormContext } from "../../../contexts";

function WalletSettlementTimePicker() {
  const { WalletSettlementTimePicker, translate: t } =
    useBatchContractSweepFormContext();
  const label = t("wallet_settlement_time");

  return (
    <>
      <div>{label}</div>
      <WalletSettlementTimePicker type={"dateTime"} />
    </>
  );
}

export default WalletSettlementTimePicker;
